import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center bg-background-50 overflow-hidden pt-16">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-20 -right-20 w-[500px] h-[500px] rounded-full bg-primary-100/30 blur-3xl"></div>
        <div className="absolute -bottom-40 -left-20 w-[600px] h-[600px] rounded-full bg-accent-100/20 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-6">
              <i className="ri-sparkling-line"></i>
              <span>Updated for 2026</span>
            </div>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold text-foreground-950 leading-[1.08] mb-6">
              The Ultimate{' '}
              <span className="text-primary-500">Hipobuy Spreadsheet</span>
              {' '}Resource Center
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 max-w-xl mb-8 leading-relaxed">
              Discover thousands of organized product finds across 14 categories. 
              Independent shopping guides, product discovery tools, and spreadsheet 
              resources to help you shop smarter and faster.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start mb-8">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-base font-semibold transition-all duration-300 hover:bg-primary-600 hover:-translate-y-1 cursor-pointer text-center"
              >
                Explore Hipobuy Spreadsheet
                <i className="ri-arrow-right-up-line ml-2"></i>
              </a>
              <Link
                to="/article/hipobuy-spreadsheet-complete-guide"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-background-100 text-foreground-900 text-base font-semibold transition-all duration-300 hover:bg-background-200 hover:-translate-y-1 cursor-pointer text-center"
              >
                View Spreadsheet Guides
                <i className="ri-article-line ml-2"></i>
              </Link>
            </div>

            <div className="flex flex-wrap items-center gap-3 md:gap-5 justify-center lg:justify-start text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500 text-base w-4 h-4 flex items-center justify-center"></i>
                Updated Guides
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500 text-base w-4 h-4 flex items-center justify-center"></i>
                Independent Research
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500 text-base w-4 h-4 flex items-center justify-center"></i>
                Shopping Education
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-checkbox-circle-fill text-accent-500 text-base w-4 h-4 flex items-center justify-center"></i>
                Global Community
              </span>
            </div>

            <div className="flex flex-wrap items-center gap-2 mt-6 justify-center lg:justify-start">
              {['Hipobuy Spreadsheet', 'Kakobuy Spreadsheet', 'CSSBuy Spreadsheet', 'Superbuy Spreadsheet', 'Oopbuy Spreadsheet'].map((kw) => (
                <span key={kw} className="px-3 py-1 rounded-full bg-background-100 text-foreground-600 text-xs font-medium border border-background-200/60">
                  {kw}
                </span>
              ))}
            </div>
          </div>

          <div className="flex-1 relative w-full max-w-lg lg:max-w-none">
            <div className="relative h-[380px] md:h-[460px]">
              <div className="absolute top-0 right-8 w-48 md:w-56 h-64 md:h-72 rounded-2xl overflow-hidden bg-background-100 rotate-[-6deg] z-10 transition-transform duration-500 hover:rotate-0 hover:scale-105">
                <img
                  src="https://readdy.ai/api/search-image?query=Designer%20limited%20edition%20sneakers%20on%20minimal%20warm%20cream%20background%2C%20trendy%20footwear%20product%20photography%2C%20clean%20editorial%20style%20with%20soft%20natural%20lighting%2C%20fashion%20ecommerce%20aesthetic%2C%20warm%20neutral%20tones&width=560&height=720&seq=hero-card-sneakers-v2&orientation=portrait"
                  alt="Trending Sneakers"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute top-8 left-4 w-52 md:w-60 h-72 md:h-80 rounded-2xl overflow-hidden bg-background-100 rotate-[3deg] z-20 transition-transform duration-500 hover:rotate-0 hover:scale-105">
                <img
                  src="https://readdy.ai/api/search-image?query=Premium%20oversized%20hoodie%20with%20embroidered%20detail%20on%20minimal%20warm%20beige%20background%2C%20streetwear%20fashion%20product%20photography%2C%20soft%20fabric%20texture%20visible%2C%20clean%20editorial%20lighting%20with%20gentle%20shadows&width=600&height=800&seq=hero-card-hoodie-v2&orientation=portrait"
                  alt="Streetwear Hoodie"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-4 right-16 w-44 md:w-52 h-60 md:h-72 rounded-2xl overflow-hidden bg-background-100 rotate-[8deg] z-0 transition-transform duration-500 hover:rotate-0 hover:scale-105">
                <img
                  src="https://readdy.ai/api/search-image?query=Designer%20crossbody%20bag%20with%20gold%20hardware%20on%20minimal%20warm%20white%20background%2C%20modern%20product%20photography%2C%20clean%20editorial%20style%20with%20soft%20natural%20lighting%2C%20lifestyle%20aesthetic&width=520&height=680&seq=hero-card-bag-v2&orientation=portrait"
                  alt="Designer Bag"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-foreground-400 text-xl w-5 h-5 flex items-center justify-center"></i>
      </div>
    </section>
  );
}